<template>
  <tbody v-if="typetable === 'solicitations' && route === '/saques-agrupados'">
    <template v-for="(item, i) in dataTable">
      <tr v-if="dataTable[i].total > 0"
        :key="`b${i}`"
        :class="{ 'line-border-bottom': !openClose.includes(i) }"
        class="collapse-line line-border-top clicked"
      >
        <td :colspan="header.length / 5" @click="openCloseLine(i)">
          <i class="fas fa-angle-down arrow"
            :class="{ active: openClose.includes(i) }"
          ></i>
        </td>
        <td :colspan="header.length / 4" @click="openCloseLine(i)">
          Data: {{ $date(item.group_date) }}
        </td>
        <td :colspan="header.length / 3" @click="openCloseLine(i)">
          Quantidade: {{ dataTable[i].total_requested }}
        </td>
        <td :colspan="header.length / 3" @click="openCloseLine(i)">
          Total: {{ currencySymbol }} {{ formatMoney(item.sum_total) }}
        </td>
        <!-- Export Data -->
        <td v-if="actions.length > 1 && route === '/saques-agrupados'"
          @click="download(item)"
        >
          <b-button v-b-tooltip.hover title="Exportar dados para planilha">
            <i class="fas fa-download download"></i>
          </b-button>
        </td>
        <td v-if="actions.length > 1 && route === '/reembolsos'"
          @click="download(item)"
        >
          <b-button v-b-tooltip.hover title="Exportar dados para planilha">
            <i class="fas fa-download download"></i>
          </b-button>
        </td>
      </tr>
      <!-- Feedback Menssage -->
      <tr v-if="validIn(dataTable) && i === 0 && typetable === 'solicitations'"
        :key="`b${i}`"
      >
        <td colspan="10">
          <div class="row justify-content-center">
            <div class="alert alert-primary" role="alert">
              Sem solicitações de saques no momento.
            </div>
          </div>
        </td>
      </tr>
      <template v-for="(un, index) in item.items">
                <Transition :key="index" name="appear">
          <tr v-show="openClose.includes(i)" :key="index">
            <template v-for="(u, dex) in un">
              <td :key="`t${dex}`">
                <!-- Cliente -->
                <div v-if="setcolor && dex === 'client'" class="externclass">
                  <div
                    class="classification saque"
                    :style="formatColor(item.withdrawals[index].user.classification)"
                    :class="{classificationTop:item.withdrawals[index].user.total_withdrawals === 1 && item.withdrawals[index].status === 'REQUESTED'}"
                  ></div>
                  <div>
                    <div v-if="item.withdrawals[index].user.total_withdrawals === 1 && item.withdrawals[index].status === 'REQUESTED'" class="primeiroSaque">
                      <p>{{ 'Primeiro Saque' }}</p>
                    </div>
                    <p>{{ u }}</p>
                  </div>
                </div>
                <!-- Score -->
                <div v-else-if="dex === 'score'">
                  <graphNew
                      :data="null"
                      :value="valueProgressBar(item,index)"
                      :max="1000"
                      :link="'/analises/participante/' + item.withdrawals[index].user.id"
                      :redirectScore="item.withdrawals[index].user.id"
                    />
                </div>
                <div v-else-if="dex === 'conta'">
                  <span v-if="item.withdrawals[index].account.international_account_type">
                    {{ (item.withdrawals[index].account.international_account_type === 'IBAN' ? 'IBAN' : 'Conta Bancária') }}
                  </span>
                  <span v-else>
                    <img src="../assets/flags-country/brazil.png" height="19">
                    {{ ` ${u}` }}
                  </span>
                </div>
                <!-- Country -->
                <div v-else-if="dex === 'country' && item.withdrawals[index].account.country">
                  <span v-b-tooltip.hover :title="item.withdrawals[index].account.country.name">
                    {{ item.withdrawals[index].account.country.country_code }}
                  </span>
                </div>
                <!-- Account Number/IBAN -->
                <div v-else-if="dex === 'agencia' && item.withdrawals[index].account.bic_swift">
                  🌎 {{ item.withdrawals[index].account.account }}
                </div>
                <!-- Account Holder, CPF/CNPJ, E-mail, Value, Date, Status, Bank, Account, Agency, Currency -->
                <div v-else>
                  {{ u }}
                </div>
              </td>
            </template>
            <!-- Actions -->
            <td>
              <div class="actions">
                <b-button
                  v-for="(action, actionIndex) in actions"
                  :key="action.variant + actionIndex"
                  v-b-tooltip.hover :title="action.tooltipText"
                  :variant="action.variant"
                  @click="action.func(un)"
                >
                  <i :class="action.classButton"></i>
                </b-button>
              </div>
            </td>
          </tr>
        </Transition>
      </template>
    </template>
  </tbody>
  <tbody v-else-if="typetable === 'historic' && route === '/saques-agrupados'">
    <template v-for="(item, i) in dataTable">
      <tr
        v-if="
          dataTable[i].total_accepted +
            dataTable[i].total_denied +
            dataTable[i].total_refunded >
          0
        "
        :key="`b${i}`"
        class="collapse-line line-border-top clicked"
        :class="{ 'line-border-bottom': !openClose.includes(i) }"
      >
        <td :colspan="header.length / 5" @click="openCloseLine(i)">
          <i
            class="fas fa-angle-down arrow"
            :class="{ active: openClose.includes(i) }"
          ></i>
        </td>
        <td :colspan="header.length / 4" @click="openCloseLine(i)"
          >Data: {{ $date(item.group_date) }}</td
        >
        <td :colspan="header.length / 3" @click="openCloseLine(i)">
          Quantidade:
          {{
            dataTable[i].total_accepted +
            dataTable[i].total_denied +
            dataTable[i].total_refunded
          }}
        </td>
        <td :colspan="header.length / 3" @click="openCloseLine(i)"
          >Total: {{ currencySymbol }} {{ formatMoney(item.sum_total) }}</td
        >
        <td v-if="actions.length > 1" @click="download(item)">
          <b-button>
            <i class="fas fa-download download"></i>
          </b-button>
        </td>
      </tr>
      <tr
        v-if="i === 0 && validateWithdrawalsHistoric()"
        :key="`b${i}`"
      >
        <td colspan="10">
          <div class="row justify-content-center pb-2 pt-3 border-custom">
            <div class="alert alert-primary" role="alert">
              Sem solicitações de saques no momento.
            </div>
          </div>
        </td>
      </tr>
      <template v-for="(un, index) in item.items">
        <Transition :key="index" name="appear">
          <tr v-show="openClose.includes(i)" :key="index">
            <template v-for="(u, dex) in un">
              <td v-if="dex !== 'score'" :key="`td${dex}`">{{ u }}</td>
              <td v-else :key="`graph${dex}`">
                <graphNew
                  :data="null"
                  :value="valueProgressBar(item, index)"
                  :max="1000"
                  :link="'/analises/participante/' + item.withdrawals[index].user.id"
                  :redirectScore="item.withdrawals[index].user.id"
                />
              </td>
            </template>
            <td>
              <div class="actions">
                <b-button
                  v-for="(action, actionIndex) in actions"
                  :key="action.variant + actionIndex"
                  :variant="action.variant"
                  @click="action.func(un)"
                >
                  <i :class="action.classButton"></i>
                </b-button>
              </div>
            </td>
          </tr>
        </Transition>
      </template>
    </template>
  </tbody>
  <tbody v-else-if="typetable === 'solicitations' && route === '/reembolsos'">
    <template v-for="(item, i) in dataTable">
      <tr
        v-if="item.count_request_refund_total > 0"
        :key="`b${i}`"
        class="collapse-line line-border-top clicked"
        :class="{ 'line-border-bottom': !openClose.includes(i) }"
      >
        <!-- Arrow Down Icon -->
        <td :colspan="header.length / 4" @click="openCloseLine(i)">
          <i class="fas fa-angle-down arrow"
            :class="{ active: openClose.includes(i) }"
          ></i>
        </td>
        <!-- Quantity -->
        <td :colspan="header.length / 5" @click="openCloseLine(i)">
          Quantidade: {{ dataTable[i].count_request_refund_group }}
        </td>
        <!-- Percent -->
        <td :colspan="header.length / 5" @click="openCloseLine(i)">
          {{ item.seller_percent }} %
        </td>
        <!-- Total -->
        <td :colspan="header.length / 2" @click="openCloseLine(i)">
          Total: {{ item.currency_symbol }}{{ calculateAmount(item.refund_solicitations) }}
        </td>
        <!-- Hand Holding $ Icon -->
        <td v-if="actions.length > 1" @click="actionline.func(item)">
          <b-button v-b-tooltip.hover title="Realizar reembolso">
            <i class="fas fa-hand-holding-usd icon icon-refund"></i>
          </b-button>
        </td>
      </tr>
      <!-- Feedback Menssage -->
      <tr v-if="item.count_request_refund_total === 0 && typetable === 'solicitation'"
        :key="`b${i}`"
      >
        <td colspan="10">
          <div class="row justify-content-center">
            <div class="alert alert-primary" role="alert">
              Sem solicitações de reembolso no momento.
            </div>
          </div>
        </td>
      </tr>
      <template v-for="(un, index) in item.items">
        <Transition :key="index" name="appear">
          <tr v-show="openClose.includes(i)" :key="index">
            <td>
              {{ un.vendedor }}
              <NewProgressBar :type="'SellerScore'" :valor="item.refund_solicitations[0].sale.seller.score.total_score" v-if="item.refund_solicitations[0].sale.seller.score && item.refund_solicitations[0].sale.seller.score.total_score"/>

            </td>
            <td>{{ un.nome }}</td>
            <td>{{ un.email }}</td>
            <td>
              <a
                :href="`https://api.whatsapp.com/send?phone=+55${
                  un.celular.replace(/[() -]/g, '')
                }`"
                target="_blank"
                class="text-success"
              >
                <i class="fab fa-whatsapp"></i>
              </a>
              {{ un.celular }}
            </td>
            <td>{{ un.product }}</td>
            <td>{{ un.valor }}</td>
            <td>{{ un.sale_id }}</td>
            <td>
              <PaymentMethodIcon :method="un.metodo" />
            </td>
            <td>{{ un.local_currency }}</td>
            <td>{{ un.base_currency }}</td>
            <td>{{ un.data }}</td>
            <td>
              <div class="actions">
                <b-button
                  v-for="(action, actionIndex) in actions"
                  :key="action.variant + actionIndex"
                  v-b-tooltip.hover :title="action.tooltipText"
                  :variant="action.variant"
                  @click="action.func(un)"
                >
                  <i :class="action.classButton"></i>
                </b-button>
              </div>
            </td>
          </tr>
        </Transition>
      </template>
    </template>
  </tbody>
<tbody v-else-if="typetable === 'historic' && route === '/reembolsos'">
    <template v-for="(item, i) in dataTable">
      <tr
        v-if="item.count_request_refund_total > 0"
        :key="`b${i}`"
        class="collapse-line line-border-top clicked"
        :class="{ 'line-border-bottom': !openClose.includes(i) }"
      >
        <td :colspan="header.length / 4" @click="openCloseLine(i)">
          <i
            class="fas fa-angle-down arrow"
            :class="{ active: openClose.includes(i) }"
          ></i>
        </td>
        <td :colspan="header.length / 5" @click="openCloseLine(i)">
          Quantidade: {{ dataTable[i].count_request_refund_group }}
        </td>
        <td :colspan="header.length / 5" @click="openCloseLine(i)">
          {{ item.seller_percent }} %
        </td>
        <td :colspan="header.length / 2" @click="openCloseLine(i)">
          Total: {{ item.currency_symbol }}{{ calculateAmount(item.refund_solicitations) }}
        </td>
        <td v-if="actions.length > 1" @click="actionline.func(item)">
          <b-button>
            <i class="fas fa-hand-holding-usd icon icon-refund"></i>
          </b-button>
        </td>
      </tr>
      <tr
        v-if="
          item.count_request_refund_total === 0 && typetable === 'solicitation'
        "
        :key="`b${i}`"
      >
        <td colspan="10">
          <div class="row justify-content-center">
            <div class="alert alert-primary" role="alert">
              Sem solicitações de reembolso no momento.
            </div>
          </div>
        </td>
      </tr>
      <template v-for="(un, index) in item.items">
        <Transition :key="index" name="appear">
          <tr v-show="openClose.includes(i)" :key="index">
            <td>{{ un.vendedor }}</td>
            <td>{{ un.nome }}</td>
            <td>{{ un.email }}</td>
            <td>
              <a :href="`https://api.whatsapp.com/send?phone=+55${un.celular.replace(/[() -]/g,'')}`"
                target="_blank"
                class="text-success"
              >
                <i class="fab fa-whatsapp"></i>
              </a>
              {{ un.celular }}
            </td>
            <td>{{ un.product }}</td>
            <td>{{ un.valor }}</td>
            <td>{{ un.sale_id }}</td>
            <td>
              <div class="in-line">
                <span
                  :class="{
                    aceitado: un.status === 'Aceitado',
                    recusado: un.status !== 'Aceitado',
                  }"
                >{{ un.status }}</span>
                <span v-if="un.metodo" class="space"><PaymentMethodIcon :method="un.metodo" /></span>
              </div>
            </td>
            <td>{{ un.local_currency }}</td>
            <td>{{ un.base_currency }}</td>
            <td>{{ un.data }}</td>
            <td>
              <div class="actions">
                <b-button
                  v-for="(action, actionIndex) in actions"
                  :key="action.variant + actionIndex"
                  :variant="action.variant"
                  @click="action.func(un)"
                >
                  <i :class="action.classButton"></i>
                </b-button>
              </div>
            </td>
          </tr>
        </Transition>
      </template>
    </template>
  </tbody>
</template>
<script>
import Money from '@src/mixins/money'
import WithdrawGroupExportService from '@services/resources/WithdrawGroupExportService'
import Vue from 'vue'
import graphNew from '@router/views/analysis/graphNew.vue';
import NewProgressBar from '@/src/components/common/new-progress-bar.vue'

var exportFile = WithdrawGroupExportService.build()

export default {
  name: 'BodyTable',
  components:{graphNew, NewProgressBar},
  mixins: [Money],
  props: {
    data: {
      type: Array,
      required: true,
      default: () => [],
    },
    setcolor: {
      type: Boolean,
      default: false,
    },
    actions: {
      type: Array,
      required: false,
      default: () => [],
    },
    header: {
      type: Array,
      required: false,
      default: () => [],
    },
    typetable: {
      type: String,
      required: false,
      default: '',
    },
    route: {
      type: String,
      required: false,
      default: '/saques-agrupados',
    },
    actionline: {
      type: Object,
      required: false,
      default: () => {},
    },
    currencySymbol: {
      type: String,
      default: "R$"
    },
    currency: {
      type: String,
      default: "BRL"
    },
  },
  data() {
    return {
      dataTable: [],
      openClose: [],
      newHeader: [],
    }
  },
  watch: {
    data: {
      handler(newValue, oldValue) {
        if (
          this.typetable === 'solicitations' &&
          this.route === '/saques-agrupados'
        ) {
          if (newValue) {
            newValue.forEach((item) => {
              if(item.withdrawals){
                item.withdrawals.forEach((element ) => {
                  item.items.forEach((itemElement, index) => {
                    if (itemElement.client === element.user.name) {
                      item.items[index] = {
                        client: itemElement.client,
                        titular: itemElement.titular,
                        cpf_cnpj: itemElement.cpf_cnpj,
                        email: itemElement.email,
                        valor: itemElement.valor,
                        data: itemElement.data,
                        status: itemElement.status,
                        banco: itemElement.banco,
                        conta: itemElement.conta,
                        agencia: itemElement.agencia,
                        currency: itemElement.currency,
                        score: element.user.score,
                        country: itemElement.country,
                      };
                    }
                  });
                });
              }
              if (item.withdraw) {
                item.withdraw.forEach((element) => {
                  if (
                    element.status === 'REQUESTED' &&
                    this.typetable === 'solicitations'
                  ) {
                    return {
                      element,
                    };
                  }
                });
              }
            })
            this.dataTable = newValue;
          }
        } else if (
          this.typetable === 'historic' &&
          this.route === '/saques-agrupados'
        ) {
          if (newValue) {
            newValue.forEach((item) => {
              if(item.withdrawals){
                item.withdrawals.forEach((element ) => {
                  item.items.forEach((itemElement, index) => {
                    if (itemElement.client === element.user.name) {
                      item.items[index] = {
                        client: itemElement.client,
                        titular: itemElement.titular,
                        cpf_cnpj: itemElement.cpf_cnpj,
                        email: itemElement.email,
                        valor: itemElement.valor,
                        data: itemElement.data,
                        status: itemElement.status,
                        banco: itemElement.banco,
                        conta: itemElement.conta,
                        agencia: itemElement.agencia,
                        currency: itemElement.currency,
                        score: element.user.score,
                        country: itemElement.country,
                      };
                    }
                  });
                });
              }
              if (item.withdraw) {
                item.withdraw.forEach((element) => {
                  if (
                    (element.status === 'DENIED' ||
                      element.status === 'REFUNDED' ||
                      element.status === 'ACCEPTED') &&
                    this.typetable === 'historic'
                  ) {
                    return {
                      element,
                    };
                  }
                });
              }
            })
            this.dataTable = newValue;
          }
        } else if (
          this.typetable === 'solicitations' &&
          this.route === '/reembolsos'
        ) {
          if (newValue) {
            newValue.forEach((item) => {
              if (item.items) {
                item.items.forEach((element) => {
                  if (
                    element.status === 'REQUESTED' &&
                    this.typetable === 'solicitations'
                  ) {
                    return {
                      element,
                    };
                  }
                });
              }
            });
            this.dataTable = newValue;
          }
        } else if (
          this.typetable === 'historic' &&
          this.route === '/reembolsos'
        ) {
          if (newValue) {
            newValue.forEach((item) => {
              if (item.items) {
                item.items.forEach((element) => {
                  if (
                    (element.status === 'DENIED' ||
                      element.status === 'REFUNDED' ||
                      element.status === 'ACCEPTED') &&
                    this.typetable === 'historic'
                  ) {
                    return {
                      element,
                    };
                  }
                });
              }
            });
            this.dataTable = newValue;
          }
        }
      },
      deep: true,
      immediate: true,
    },
  },
  mounted() {
    this.startOpenClose()
  },
  methods: {
        valueProgressBar(item, index){
      if(item && item.withdrawals && item.withdrawals[index] && item.withdrawals[index].user && item.withdrawals[index].user.score && item.withdrawals[index].user.score.total_score){
        return item.withdrawals[index].user.score.total_score
      }
      return 0;
    },
    formatColor(type) {
      if (type) {
        if (type === 'green') {
          return 'background: #00E4A0'
        }
        if (type === 'yellow') {
          return 'background: #fff700'
        }
        if (type === 'red') {
          return 'background: #FF0A44'
        }
        if (type === 'black') {
          return 'background: #000000'
        }
      } else {
        return 'background:#c7c7c7;'
      }
    },
    validIn(value) {
      let res = 0
      if (value) {
        value.forEach((item) => {
          if (item.total) {
            res += 1
          }
        })
      }

      return !res
    },
    download(item) {
      Vue.swal({
        title: 'exportar arquivo',
        text: 'Tem certeza que deseja exportar o arquivo',
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Ok',
        cancelButtonText: 'Cancelar',
        confirmButtonClass: 'btn btn-warning mt-2 mr-2',
        cancelButtonClass: 'btn btn-info mt-2',
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          let data = {
            date: item.group_date.slice(0, 10),
            currency: this.currency
          }

          exportFile
            .blob(data)
            .then((resp) => {
              Vue.swal({
                title: 'Exportação',
                text: 'Exportação realizada com sucesso!',
                type: 'success',
                showCancelButton: false,
                confirmButtonText: 'Ok',
                confirmButtonClass: 'btn btn-warning',
                buttonsStyling: false,
              }).then((result) => {
                if (result.value) {
                  const url = window.URL.createObjectURL(new Blob([resp]))
                  const link = document.createElement('a')
                  link.href = url
                  link.setAttribute('download', 'relatorio-saques.xlsx')
                  document.body.appendChild(link)
                  link.click()
                  document.body.removeChild(link)
                }
              })
            })
            .catch(() => {
              Vue.swal({
                title: 'Exportação',
                text: 'Ocorreu um erro durante o processamento da exportação.',
                type: 'error',
                showCancelButton: false,
                confirmButtonText: 'Ok',
                confirmButtonClass: 'btn btn-warning',
                buttonsStyling: false,
              })
            })
        }
      })
    },
    startOpenClose() {
      for (let i = 0; i < this.data.length; i++) {
        this.openClose.push(i)
      }
    },
    openCloseLine(position) {
      const have = this.openClose.indexOf(position)
      if (have !== -1) {
        this.openClose.splice(have, 1)
      } else {
        this.openClose.push(position)
      }
    },
    calculateAmount(items) {
      let sumLine = 0
      if (items) {
        items.forEach((item) => {
          sumLine += item.amount || item.sale.amount
        })
      }

      return `${this.formatMoney(sumLine)}`
    },
    validateWithdrawalsHistoric() {
      if(this.dataTable.some(d => d.withdrawals.length > 0)) {
        return false
      } else return true;
    }
  }
}
</script>
<style lang="scss" scoped>
.primeiroSaque {
  width: 85px;
  color: #009488;
  background: #e1f4f3; 
  font-size: 11px;
  padding: 3px;
  border-radius:8px;
  text-align: center;
}
.classificationTop {
  top: 28px !important;
}
table {
  width: 100%;
  // border-collapse: collapse;
  font-size: 14px;
  thead {
    font-weight: 600;
    tr {
      th {
        &:first-child {
          border-radius: 10px 0 0 0;
        }
        &:last-child {
          border-radius: 0 10px 0 0;
        }
      }
    }
  }

  tbody {
    tr {
      position: relative;
      &:nth-child(even) {
        background-color: #fff;
      }
    }
  }

  thead,
  tbody {
    font-family: 'Nunito', sans-serif;
    font-size: 14px;
    font-style: normal;
    text-align: left;
  }
}

tbody tr td,
thead tr th {
  padding: 0.85rem;
}

.center {
  text-align: center;
  cursor: pointer;

  img {
    max-width: 24px;
    width: 100%;
  }
}

.actions {
  gap: 5px;
  display: grid;
  grid-template-columns: 1fr 1fr;
}

.collapse-line {
  z-index: 9;
  position: relative;
  cursor: pointer;
  opacity: 0.7;
  transition: 0.3s;
  color: #222;

  td {
    font-weight: 600;
  }

  &:hover {
    opacity: 1;
  }
}

.appear-enter-active,
.appear-leave-active {
  transition: opacity 0.3s ease-in-out;
}

.appear-enter,
.appear-leave-to {
  opacity: 0;
}

.appear-leave,
.appear-enter-to {
  opacity: 1;
}

.arrow {
  transform: rotate(-90deg);
  transition: 0.3s;

  &.active {
    transform: rotate(0deg);
  }
}
.line-border-top {
  border-top: 1px solid #ededf0;
}
.line-border-bottom {
  border-bottom: 1px solid #ededf0;
}

.icon-file {
  font-size: 36px !important;
}

.icon-refund {
  font-size: 24px !important;
}
.in-line {
  display: flex;
  align-items: center;
}

.space {
  margin-left: 5px;
}

.aceitado {
  border-radius: 4px;
  padding: 1px 2px;
  color: #fff;
  font-size: 9px;
  background-color: #008883;
}
.recusado {
  border-radius: 4px;
  padding: 1px 2px;
  color: #fff;
  font-size: 9px;

  background-color: #991212;
}

.border-custom {
  border: 1px solid #ccc;
  border-right-color: transparent;
  border-left: transparent;
}
</style>
